// SEO and Accessibility utilities for The Random Store

export const generateImageAlt = (productName, imageIndex = 0, context = 'product') => {
  switch (context) {
    case 'product':
      return `${productName}${imageIndex > 0 ? ` - Image ${imageIndex + 1}` : ''}`;
    case 'thumbnail':
      return `${productName} thumbnail ${imageIndex + 1}`;
    case 'gallery':
      return `${productName} gallery image ${imageIndex + 1}`;
    case 'video-thumbnail':
      return `${productName} video ${imageIndex + 1} thumbnail`;
    case 'custom-upload':
      return `Custom image ${imageIndex + 1} for ${productName}`;
    default:
      return productName;
  }
};

export const generateVideoAlt = (productName, videoIndex = 0) => {
  return `${productName} demonstration video${videoIndex > 0 ? ` ${videoIndex + 1}` : ''}`;
};

export const generateProductKeywords = (product, categories = []) => {
  const keywords = [
    product.name,
    'custom products',
    'the random store'
  ];
  
  // Add category names
  if (product.categoryNames && Array.isArray(product.categoryNames)) {
    keywords.push(...product.categoryNames);
  } else if (product.categoryName) {
    keywords.push(product.categoryName);
  }
  
  // Add color names if available
  if (product.colors && Array.isArray(product.colors)) {
    keywords.push(...product.colors);
  }
  
  // Add material/tags if available
  if (product.tags && Array.isArray(product.tags)) {
    keywords.push(...product.tags);
  }
  
  return keywords.join(', ');
};

export const generateMetaDescription = (product) => {
  const baseDescription = `Shop ${product.name} at The Random Store.`;
  const customText = product.description 
    ? ` ${product.description.slice(0, 100)}...` 
    : ' Custom products made just for you.';
  const priceText = product.price 
    ? ` Starting at ₹${Number(product.price).toLocaleString()}.` 
    : '';
  
  return (baseDescription + customText + priceText).slice(0, 160);
};

export const generateCanonicalUrl = (path) => {
  const baseUrl = 'https://therandomstores.com';
  return `${baseUrl}${path.startsWith('/') ? path : `/${path}`}`;
};

export const generateBreadcrumbSchema = (breadcrumbs) => {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbs.map((crumb, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": crumb.name,
      "item": crumb.url
    }))
  };
};
